export default (value) => {
  const primitives = [undefined, null, true, false];
  const primitiveTypes = ['string', 'number'];

  return primitives.includes(value) || primitiveTypes.includes(typeof value);
}
